var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',_vm._g(_vm._b({ref:"cascafer",staticClass:"address-cascader",attrs:{"props":_vm.props,"options":_vm.options,"clearable":"","append-to-body":false},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'el-cascader',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }